/*=============================================== BackToTopPage ===============================================*/

import { Link } from "react-router-dom"
import { Text } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps, iconBoxicon } from "data"

const BackToTopPage = () => {
    const items: ItemType[] = [
        {
            content: (
                <Text>
                    <Link
                        to="/components/back-to-top/demo"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        Demo here.
                    </Link>
                </Text>
            ),
            code: "<BackToTop />",
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "icon",
            intro: commonProps.addIconCapital,
            type: "string",
            default: iconBoxicon("arrow-top"),
        },
        {
            subtitle: "color",
            type: "string",
            possible: commonProps.colorsHover,
            default: "primary",
        },
        {
            subtitle: "variant",
            type: "string",
            possible: ["plain", "transparent", "ghost"],
            default: "plain",
        },
        {
            subtitle: "text",
            type: "string",
            default: "Back to top",
        },
        {
            subtitle: "showText",
            type: "string or boolean",
            possible: ["true", "false", "always", "hover"],
            default: "hover",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default BackToTopPage
